// test760
(760 && 0);
